import { Routes } from '@angular/router';
import { Home } from './home/home';
import { CourseLanding } from './course-landing/course-landing';

export const routes: Routes = [
  { path: '', component: Home, title: 'Gaeli – Gestión & Calidad Corporativa' },
  { path: 'cursos/:slug', component: CourseLanding },
  { path: '**', redirectTo: '' },
];
